module.exports = __webpack_public_path__ + "img/green_112.2cf2d8ad.png";